import { useSideMenu } from '@/components/NewHeader/SideMenu/useSideMenu';
import { useHeaderScroll } from '@/components/NewHeader/useHeaderScroll';
import { cn } from '@/lib/utils';
import React from 'react';

export const SideMenuTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<'button'>
>((props, ref) => {
  const { isOpen, toggle } = useSideMenu();
  const { isActive } = useHeaderScroll();

  return (
    <button
      ref={ref}
      className="relative w-[27px] h-[20px]"
      onClick={toggle}
      {...props}>
      <span
        className={cn(
          'absolute top-0 left-0 h-[2px] w-full transition-all duration-300',
          isActive ? 'bg-current' : 'bg-white',
          isOpen && 'bg-current rotate-45 top-[9px]',
        )}></span>
      <span
        className={cn(
          'absolute top-[45%] left-0 h-[2px] w-full transition-all duration-300',
          isActive ? 'bg-current' : 'bg-white',
          isOpen && 'opacity-0',
        )}></span>
      <span
        className={cn(
          'absolute bottom-0 left-0 h-[2px] w-full transition-all duration-300',
          isActive ? 'bg-current' : 'bg-white',
          isOpen && 'bg-current -rotate-45 bottom-[9px]',
        )}></span>
    </button>
  );
});

SideMenuTrigger.displayName = 'SideMenuTrigger';
